module.exports = __webpack_public_path__ + "img/fowardSimple.ea029c11.svg";